// Simple 1D Perlin Noise implementation
// Based on standard Perlin noise algorithms

const PERLIN_YWRAPB = 4;
const PERLIN_YWRAP = 1 << PERLIN_YWRAPB;
const PERLIN_ZWRAPB = 8;
const PERLIN_ZWRAP = 1 << PERLIN_ZWRAPB;
const PERLIN_SIZE = 4095;

let perlin_octaves = 4; // default to medium detail
let perlin_amp_falloff = 0.5; // 50% reduction/octave

const scaled_cosine = (i) => 0.5 * (1.0 - Math.cos(i * Math.PI));

let perlin; // will be initialized lazily (on first call) or manually

const noise = (x) => {
    if (perlin == null) {
        perlin = new Array(PERLIN_SIZE + 1);
        for (let i = 0; i < PERLIN_SIZE + 1; i++) {
            perlin[i] = Math.random();
        }
    }

    if (x < 0) x = -x;

    let xi = Math.floor(x);
    let xf = x - xi;
    let rxf, r;

    let r1, r2, n1, n2;

    r = 0;
    let ampl = 0.5;

    for (let o = 0; o < perlin_octaves; o++) {
        let of = xi + (xf * PERLIN_SIZE); // offset

        r1 = scaled_cosine(xf);
        r2 = scaled_cosine(xf - 1); // not used? check algo

        n1 = perlin[xi & PERLIN_SIZE];
        n1 += r1 * (perlin[(xi + 1) & PERLIN_SIZE] - n1);
        
        // simple 1D interpolation
        // n1 is interpolated value at x
        
        // Actually, let's use a simpler 1D interpolation for clarity if the above is confusing
        // But let's stick to a standard implementation structure
        
        // Re-implementing a cleaner 1D loop
        let frequency = 1 << o;
        let amplitude = Math.pow(perlin_amp_falloff, o);
        
        let sampleX = x * frequency;
        let sampleXi = Math.floor(sampleX);
        let sampleXf = sampleX - sampleXi;
        
        let v1 = perlin[sampleXi & PERLIN_SIZE];
        let v2 = perlin[(sampleXi + 1) & PERLIN_SIZE];
        
        let interpolated = v1 + scaled_cosine(sampleXf) * (v2 - v1);
        
        r += interpolated * amplitude;
    }
    
    return r;
};

export const generateNoise = (x) => {
    // Normalize output roughly to 0-1 range
    return noise(x);
};
